module.exports = __webpack_public_path__ + "media/notification.b79d2dd1.ogg";